module.exports = __webpack_public_path__ + "static/cartepostale-DEI-lesfemmespeuventdirenon-1200-a43d29158140924055690a365ff75f91.png";